export interface CashPeriodDataInterface {
	updateDate: string;
	txDate: string;
	depositDoneSum: number;
	withdrawalDoneSum: number;
	depositHoldSum: number;
	withdrawalHoldSum: number;
}

export interface CashPeriodSumDataInterface {
	depositSum: number;
	withdrawalSum: number;
	netDifference: number;
}

export const emptyCashPeriodSum: CashPeriodSumDataInterface = {
	withdrawalSum: 0,
	depositSum: 0,
	netDifference: 0,
}